import { useGlobalContentStore } from '~/store/globalContent';

export default defineNuxtRouteMiddleware(() => {
  const globalContentStore = useGlobalContentStore();
  if (globalContentStore.getIsNonEcomSite) {
    setPageLayout('corporate');
  }
});
